<div class="m-top-i">
    <div class="userinfo full" *ngIf="plazo_equipo.length==0 && serv_ad.length==0">
      <div class="col-xs-12 col-sm-12">
        <div>
          <div class="basicrow m-bott">
            <div class="basicrow f-bmed roboto-b m-bott">
              Detalle del Plan
            </div>
            <div class="redstat">
              <div class="autorow roboto-r pull-left nom-plan ">
                {{yz}}  
              </div>
              <div class="autorow roboto-b pull-right ">
                {{valor_de_plan | currency}}
              </div>
            </div>
          </div>
          <div class="basicrow m-top-ii">
            <div class="basicrow f-reg roboto-b m-bott">
              Descripci&oacute;n del Plan:
            </div>
            <div class="descripcion-plan" [innerHtml]="descr_plan"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="userinfo full" *ngIf="(1> plazo_equipo.length || 1> serv_ad.length) && type_plan=='fixed'">
      <div class="col-xs-12 col-sm-12">
        <div>
          <div class="basicrow m-bott">
            <div class="basicrow f-bmed roboto-b m-bott">
              Detalle del Plan
            </div>
            <div class="redstat">
              <div class="autorow roboto-r pull-left nom-plan">
                {{yz}}
              </div>
              <div class="autorow roboto-b pull-right">
                {{valor_de_plan | currency}}
              </div>
            </div>
          </div>
          <div class="basicrow m-top-ii">
            <div class="basicrow f-reg roboto-b m-bott">
              Descripci&oacute;n del Plan:
            </div>
            <div class="descripcion-plan" [innerHtml]="descr_plan"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="left-all" *ngIf="plazo_equipo.length > 0 || serv_ad.length > 0 || ins_eq > 0">
      <div class="userinfo normal">
        <div class="basicrow m-bott">
          <div class="basicrow f-bmed roboto-b m-bott">
            Detalle del Plan
          </div>
          <div class="redstat">
            <div class="autorow roboto-r pull-left nom-plan ajuste1">
              {{yz}} 
            </div>
            <div class="autorow roboto-b pull-right ajuste2">
              {{valor_de_plan |currency}}
            </div>
          </div>
        </div>
        <div class="basicrow m-top-ii">
          <div class="basicrow f-reg roboto-b m-bott">
            Descripci&oacute;n del Plan:
          </div>
          <div class="descripcion-plan" [innerHtml]="descr_plan"></div>
        </div>
      </div>
    </div>
</div>